import React, { Component } from 'react';
import { Panel, Button } from 'react-bootstrap';
import { history } from '../../helpers';
import DangerButton from '../Misc/DangerButton';
import '../../content/css/PortfolioAnalysis/PortfolioAnalysis.css';

export default class PortfolioAnalysisInsights extends Component {
    constructor(props) {
        super(props);
    }

    handleExport = () => {
        this.props.onExportReport(this.props.id);
    }

    handleRecreate = () => {
        let documentIds = this.props.documents.map(x => x.id);
        this.props.onCreateNewReport(`Re-run of ${this.props.name}`, this.props.description, documentIds);
        history.push('/reports');
    }

    handleDelete = () => {
        this.props.onDelete(this.props.id);
        history.push('/reports');
    }

    render() {
        let path = this.props.match ? this.props.match.path : "";
        return (
            <div className="portfolio-analysis-settings">
                <Panel>
                    <div className="panel-title-column">
                        <span className="panel-title">Re-create report</span>
                        <span>Create a new report based on the same documents and theme.</span>
                    </div>
                    <Button onClick={this.handleRecreate}>New report</Button>
                    <hr />
                    <div className="panel-title-column">
                        <span className="panel-title">Export</span>
                        <span>Export the report to excel.</span>
                    </div>
                    <Button onClick={this.handleExport}>Export</Button>
                    <hr />
                    <div className="panel-title-column">
                        <span className="panel-title">Delete</span>
                        <span>Permanently delete the report. Cannot be undone.</span>
                    </div>
                    <DangerButton warningText="Are you sure you want to delete the report?" onClick={this.handleDelete}>Delete</DangerButton>
                </Panel>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/AnalysisReports/PortfolioAnalysisSettings.js